import { Users } from 'lucide-react'
import type { ModuleDefinition } from '../types'
import { lazyPage } from '@/lib/lazyPage'

const OneOnOnesPage = lazyPage(() => import('@/pages/OneOnOnes'), 'OneOnOnesPage')

export const oneOnOnesModule: ModuleDefinition = {
  key: 'oneOnOnes',
  icon: Users,
  iconName: 'users',
  namespaces: ['oneOnOnes'],
  ready: true,
  opensOnCreate: true,
  /* Each person's series with their leader or reports (F-136 criterion 1): no "one or many", nothing to set up. */
  ListPage: OneOnOnesPage,
  posting: false,
  workflow: {
    trigger: { block: 'oneOnOnes', hrPrefixes: ['one_on_one.', 'time.one_on_one_', 'time.agreement_'] },
    spaceActions: ['oneOnOne.schedule']
  }
}
